<template>
  <div class="TranPost">
    <div class="TranActs-background">
      <div class="AgstOpel-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        转存
      </div>
      <router-link :to="{path: 'CardBag',query: {HoCardBag: '6'}}">
        <div class="TranActs-CardTion TranPost-CardTion">
            <div class="TranActs-CardTion-left TranPost-CardTion-left"></div>
            <div class="TranActs-CardTion-center TranPost-CardTion-center">
            <p class="TranActs-CardTion-center-text TranPost-CardTion-center-text">转入卡号</p>
            <p>{{this.trchbr}}</p>
            </div>
            <div class="TranActs-CardTion-right TranPost-CardTion-right"></div>
        </div>
      </router-link>
      <div class="TranPost-outins">
        <el-input v-model="TranSfut" placeholder="转出卡号" clearable @input="TranErot()"></el-input>
      </div>
      <div class="TranActs-OpelNumber TranPost-OpelNumber">
        <p class="TranActs-OpelNumber-text TranPost-OpelNumber-text">转出欧宝</p>
        <div class="TranActs-OpelNumber-Recharge TranPost-OpelNumber-Recharge">
          <span>￥</span>
          <el-input type="Number" pattern="[0-9]*" v-model="TranFoel" placeholder="请输入转出欧宝" clearable @input="TranOpel()"></el-input>
        </div>
      </div>
      <div class="TranPost-outins TranPost-caswod">
        <span>转出卡密码</span>
        <el-input type="password" v-model="TranCasd" placeholder="请输入转出卡密码" clearable show-password @input="TranCaod()"></el-input>
      </div>
      <button class="TranActs-confirm" @click="trancorm()">确认</button>
      <div class="TranActs-reminder" v-show="isOriginHei">- 持卡人账户内不同类型卡之间的转入转出 -</div>
    </div>
    <!-- 失败提示 -->
    <div id="warnToast" :style="'display:' + tranfail">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-warn weui-icon_toast"></i>
        <p class="weui-toast__content">{{trantips}}</p>
      </div>
    </div>
    <!-- 成功提示 -->
    <div id="toast" :style="'display:' + transucs">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-success-no-circle weui-icon_toast"></i>
        <p class="weui-toast__content">{{trantips}}</p>
      </div>
    </div>
    <TextTips></TextTips>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      TranSfut: '',
      TranFoel: '',
      TranCasd: '',
      loginID: '',
      trchbr: '',
      tranfail: 'none',
      trantips: '',
      transucs: 'none',
      isOriginHei: true,
      screenHeight: document.documentElement.clientHeight,
      originHeight: document.documentElement.clientHeight
    }
  },
  created () {
    // 从缓存里获取token
    this.loginID = localStorage.getItem("usertoken");
    // 接收选择卡号(卡包)传过来的卡号
    this.trchbr = this.$route.query.sechbr;
  },
  mounted () {
    let that = this;
    window.onresize = function() {
      return (function(){
        that.screenHeight = document.documentElement.clientHeight;
      })()
    }
  },
  watch:{
    screenHeight (val) {
      if(this.originHeight > val + 100) {        //加100为了兼容华为的返回键
        this.isOriginHei = false;
      }else{
        this.isOriginHei = true;
      }
    }
  },
  methods: {
    // 获取转出卡号
    TranErot(){
      // console.log(this.TranSfut);
    },
    // 获取要转出的欧宝数
    TranOpel(){
      // console.log(this.TranFoel);
    },
    // 获取输入的卡密码
    TranCaod(){
      // console.log(this.TranCasd);
    },
    // 点击确认提交转存信息
    trancorm(){
      if(this.TranSfut == ''){
        this.trantips = '转出卡号不能为空';
        this.tranfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.tranfail = 'none';
        },1200)
      }else if(this.TranFoel == ''){
        this.trantips = '转出欧宝不能为空';
        this.tranfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.tranfail = 'none';
        },1200)
      }else if(this.TranCasd == ''){
        this.trantips = '密码不能为空';
        this.tranfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.tranfail = 'none';
        },1200)
      }else{
        this.$axios.post('app/cardUnloading',this.$qs.stringify({
          token: this.loginID,
          transferusercard: this.trchbr,
          cnumber: this.TranSfut,
          amtoritl: this.TranFoel,
          cpassword: this.TranCasd,
          transfertype: '1'
        }),{headers:{'token': this.loginID}})
        .then(res => {
          if(res.data.code == '200'){
            this.trantips = res.data.msg;
            this.transucs = 'block';
            const _this = this;
            setTimeout(function(){
              _this.transucs = 'none';
              _this.TranCasd = '';
            },1200)
          }else{
            this.trantips = res.data.msg;
            this.tranfail = 'block';
            const _this = this;
            setTimeout(function(){
              _this.tranfail = 'none';
              _this.TranCasd = '';
            },1200)
          }
        })
        .catch(() => {
          console.log('获取失败');
        });
      }
    },
    // 返回上一层
    BackLevel(){
      this.$router.push({name: 'HomePage'});
    }
  }
}
</script>

<style scoped>
  @import "obraocs/TranActs.css";
</style>